import { Button, Icons, Stack, Typography } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { PatientBasicsDto, PatientBasicsDtoCaseType, TaskDto } from '../../../api/generated/model';
import { SubCard } from '../../../components/SubCard.tsx';
import { formatLocalDateTimeWithGermanMonthDateOnly } from '../../../utils/date.ts';

function navigateByCaseType(
  navigate: ReturnType<typeof useNavigate>,
  patientId: string,
  caseType: PatientBasicsDtoCaseType | undefined,
  screeningCaseId: string | null | undefined,
) {
  switch (caseType) {
    case PatientBasicsDtoCaseType.INDEX:
      void navigate({ to: '/patients/$patientId', params: { patientId } });
      return;
    case PatientBasicsDtoCaseType.TRACING_CONTACT:
      void navigate({ to: '/contact-tracing/$patientId', params: { patientId } });
      return;
    case PatientBasicsDtoCaseType.SCREENING_INDIVIDUAL:
      if (screeningCaseId) {
        void navigate({
          to: '/screening/$screeningId/individuals/$individualId',
          params: { screeningId: screeningCaseId, individualId: patientId },
        });
      }
      return;
  }
}

export function TaskNotic({ task, patient }: { task: TaskDto; patient: PatientBasicsDto }) {
  const navigate = useNavigate();
  const journalPatient = task.journal?.patient;
  const patientId = journalPatient?.id ?? task.patientId;
  const caseType = journalPatient?.caseType;
  const screeningCaseId =
    caseType === PatientBasicsDtoCaseType.SCREENING_INDIVIDUAL ? task.referenceId : null;
  const isNavigationDisabled =
    caseType === PatientBasicsDtoCaseType.SCREENING_INDIVIDUAL && !screeningCaseId;
  const patientName = [patient.firstName, patient.lastName].filter(Boolean).join(' ');
  const noteText = task.notes || task.journal?.notes || 'Keine Beschreibung des To Dos eingetragen';

  return (
    <Stack direction={'row'}>
      <Stack flex={1} gap={2}>
        <Stack direction={'row'} gap={2}>
          <SubCard>
            <Icons.BloodtypeOutlined size={'sm'} />
          </SubCard>
          <Stack justifyContent={'space-between'}>
            <Typography sx={{ whiteSpace: 'pre-line' }} level={'title-lg'}>
              {noteText}
            </Typography>
            <Typography level={'body-sm'}>{formatLocalDateTimeWithGermanMonthDateOnly(task.due)}</Typography>
          </Stack>
        </Stack>
        <Typography sx={{ whiteSpace: 'pre-line' }} level={'title-sm'}>
          {patientName}
        </Typography>
      </Stack>
      <Button
        sx={{ alignSelf: 'flex-start' }}
        endDecorator={<Icons.ArrowForward />}
        disabled={isNavigationDisabled}
        onClick={() => navigateByCaseType(navigate, patientId, caseType, screeningCaseId)}>
        Zur Diagnostik
      </Button>
    </Stack>
  );
}
